<template>
  <div>
    <div class="page flex-col">
    <!-- 头部导航组件 -->
    <HeaderNav />
    
    <div class="box_1 flex-col">
      <!-- 统一的顶部装饰和图片 -->
      <div class="box_1-spacer flex-col"></div>
      <div class="box_2 flex-col"></div>
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        :src="getImageUrl(siteConfig?.config?.['pic_人文纪念']) || '/files/images/M6.jpg'"
      />
      <div class="news-content flex-col">
        <div class="news-header flex-col">
          <h1 class="news-title">人文纪念</h1>
          <p class="news-subtitle">HUMANISTIC COMMEMORATION</p>
        </div>
      </div>
      <div class="group-container flex-col">
        <!-- 第一层：逝者选择 -->
        <div class="away-selection-wrapper flex-col">
          <span class="text_15">逝者</span>
          <div class="text-wrapper_3 flex-col">
            <select 
              v-model="selectedAwayId" 
              @change="handleAwayChange"
              class="away-select"
            >
              <option value="" disabled>请选择</option>
              <option 
                v-for="item in awayList" 
                :key="item.id" 
                :value="item.id"
              >
                {{ item.name || '未命名' }}
              </option>
            </select>
          </div>
        </div>
        <!-- 第二层：左右结构 -->
        <div class="second-layer flex-row">
          <div class="group_6 flex-col">
            <div 
              v-for="item in rememberList" 
              :key="item.id"
              :class="['text-wrapper_2', 'flex-col', { 'selected': selectedRemember && selectedRemember.id === item.id }]"
              @click="selectRemember(item)"
              style="cursor: pointer;"
            >
              <span class="text_14">{{ item.title }}</span>
            </div>
          </div>
          <div 
            class="image-wrapper-large flex-col"
            :style="selectedRemember && selectedRemember.cover ? {
              backgroundImage: `url(${getImageUrl(selectedRemember.cover)})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            } : {}"
          >
          </div>
        </div>
        <!-- 第三层：立即上香按钮 -->
        <!-- <div class="group_8 flex-row">
          <div class="text-wrapper_10 flex-col justify-between">
            <span class="text_23">{{ selectedRemember ? selectedRemember.title : '上香' }}</span>
            <span class="text_24">{{ selectedRemember ? selectedRemember.title.toUpperCase().replace(/\s/g, ' ') : 'OFFERING&nbsp;INCENSE' }}</span>
          </div>
          <div class="group_9 flex-col"></div>
          <div 
            class="text-wrapper_11 flex-col" 
            @click="handleCreateOrder"
            style="cursor: pointer;"
          >
            <span class="text_25">立即{{ selectedRemember ? selectedRemember.title : '上香' }}</span>
          </div>
        </div> -->
      </div>
    </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>
<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getRemembers, getAwayList, createRememberOrder } from '@/api/home';
import { getImageUrl } from '@/config/api';
import { getSiteConfig } from '@/store/siteConfig';
import { Toast } from 'vant';

export default {
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      constants: {},
      rememberList: [],
      selectedRemember: null,
      awayList: [], // 逝者列表
      selectedAwayId: '', // 选中的逝者ID
      submitting: false // 提交中状态
    };
  },
  computed: {
    siteConfig() {
      return getSiteConfig();
    }
  },
  mounted() {
    this.fetchRemembers();
    this.fetchAwayList();
  },
  methods: {
    // 获取人文纪念列表
    async fetchRemembers() {
      try {
        const res = await getRemembers();
        if (res.code === 0 && res.data && res.data.list) {
          this.rememberList = res.data.list;
          // 默认选中第一个人文纪念项，用于首次进入时渲染图片和标题
          if (this.rememberList.length > 0 && !this.selectedRemember) {
            this.selectedRemember = this.rememberList[0];
          }
        }
      } catch (error) {
        console.error('获取人文纪念列表失败:', error);
      }
    },
    // 获取逝者列表
    async fetchAwayList() {
      try {
        const res = await getAwayList();
        if (res.code === 0 && res.data && res.data.list) {
          this.awayList = res.data.list;
          // 首次进入时，如果还未选择逝者，则默认选中第一个
          if (this.awayList.length > 0 && !this.selectedAwayId) {
            this.selectedAwayId = this.awayList[0].id?.toString() || '';
          }
        }
      } catch (error) {
        console.error('获取逝者列表失败:', error);
        this.awayList = [];
      }
    },
    // 处理逝者选择变化
    handleAwayChange(event) {
      const value = event.target.value;
      this.selectedAwayId = value;
      const selectedAway = this.awayList.find(item => item.id == value);
      if (selectedAway) {
        console.log('选中的逝者:', selectedAway);
        // 可以在这里添加选择后的逻辑
      }
    },
    // 选择人文纪念项
    selectRemember(item) {
      console.log('选择人文纪念项:', item);
      this.selectedRemember = item;
      // 可以在这里添加选择后的逻辑，比如更新"上香"区域的显示
    },
    // 获取图片URL
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    },
    // 处理立即上香
    async handleCreateOrder() {
      console.log('当前选中状态:', {
        selectedRemember: this.selectedRemember,
        selectedAwayId: this.selectedAwayId
      });
      
      // 验证是否选择了人文纪念项
      if (!this.selectedRemember || !this.selectedRemember.id) {
        Toast.fail('请选择人文纪念类型');
        return;
      }
      
      // 验证是否选择了逝者
      if (!this.selectedAwayId) {
        Toast.fail('请选择逝者');
        return;
      }
      
      // 防止重复提交
      if (this.submitting) {
        return;
      }
      
      this.submitting = true;
      
      try {
        const res = await createRememberOrder({
          remember_id: this.selectedRemember.id.toString(),
          away_id: this.selectedAwayId.toString()
        });
        
        if (res.code === 0) {
          Toast.success('下单成功');
          // 可以在这里添加成功后的逻辑，比如跳转或刷新
        } else {
          Toast.fail(res.msg || '下单失败，请重试');
        }
      } catch (error) {
        console.error('下单失败:', error);
        Toast.fail('下单失败，请重试');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.footer-wrapper {
  margin: 0 auto;
}

/* box_3 - 自适应 */
/* 统一的顶部装饰和图片样式 */
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.image_1 {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  object-fit: cover !important;
  display: block !important;
  box-sizing: border-box !important;
}

/* 新闻内容区域 - 自适应 */
.news-content {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 42px auto 0 !important;
  padding: 40px 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}

.news-header {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  margin-bottom: 50px !important;
  padding-bottom: 30px !important;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2) !important;
  box-sizing: border-box !important;
}

.news-title {
  width: auto !important;
  height: auto !important;
  font-size: clamp(28px, 4vw, 36px) !important; /* 响应式字体 */
  font-weight: bold !important;
  color: rgba(0, 149, 151, 1) !important;
  margin: 0 0 10px 0 !important;
  text-align: center !important;
  line-height: 1.2 !important;
}

.news-subtitle {
  width: auto !important;
  height: auto !important;
  font-size: clamp(14px, 1.5vw, 18px) !important; /* 响应式字体 */
  color: #666 !important;
  margin: 0 !important;
  text-align: center !important;
  letter-spacing: 2px !important;
  line-height: 1.2 !important;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .image_1 {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }

  .news-content {
    padding: 30px 15px !important;
    margin: 30px auto 0 !important;
  }

  .news-header {
    margin-bottom: 30px !important;
    padding-bottom: 20px !important;
  }

  .box_1 > .box_3 {
    margin-right: 10px !important;
  }

  .group_6 {
    padding: 0 10px !important;
    gap: 10px !important;
  }

  .text-wrapper_2 {
    min-width: 90px !important;
    padding: 0 8px !important;
  }

  .text-wrapper_3 {
    margin-left: 10px !important;
    max-width: 100% !important;
  }

  .group_7 {
    padding: 0 10px !important;
    gap: 15px !important;
  }

  .image-wrapper-large {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 400px !important;
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }

  .group_8 {
    padding: 20px 15px !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px !important;
  }

  .text-wrapper_10 {
    margin: 0 !important;
    align-items: center !important;
  }

  .group_9 {
    display: none !important;
  }

  .text-wrapper_11 {
    margin: 0 !important;
    width: 100% !important;
    max-width: 194px !important;
  }
}

/* 逝者选择框样式 - 使用原生select */
.text-wrapper_3 {
  position: relative;
}

.away-select {
  width: 100%;
  height: 38px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 4px;
  padding: 0 12px;
  font-size: 13px;
  color: rgba(92, 92, 92, 1);
  font-family: AlibabaPuHuiTi_2_55_Regular;
  line-height: 38px;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%235c5c5c' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 8px;
  padding-right: 32px;
  transition: all 0.3s ease;
}

.away-select:hover {
  border-color: rgba(0, 149, 151, 0.5);
  box-shadow: 0 2px 8px rgba(0, 149, 151, 0.15);
}

.away-select:focus {
  border-color: rgba(0, 149, 151, 1);
  box-shadow: 0 2px 8px rgba(0, 149, 151, 0.2);
}

.away-select option {
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  background-color: #ffffff;
}

.away-select option:hover {
  background-color: rgba(0, 149, 151, 0.08);
}

.away-select option:checked {
  background-color: rgba(0, 149, 151, 0.1);
  color: rgba(0, 149, 151, 1);
  font-weight: 500;
}

.away-select option[disabled] {
  color: rgba(92, 92, 92, 0.5);
}

/* group_7 样式已在 index.css 中设置为自适应 */

/* 人文纪念按钮选中状态 */
.text-wrapper_2.selected {
  opacity: 0.8;
  transform: scale(0.98);
}

.text-wrapper_2.selected .text_14 {
  font-weight: 600;
}
</style>
